import { post, get, deletefn, putfun } from './http.js'
export default {
    // 短信验证
    async verify (params) {
        return await post('/common/verify-code',params)
    },
    // 密码登录
    async firmLogin (params) {
      return await post('/firm/login', params)
    },
    async userLogin (params) {
      return await post('/login', params)
    },
    // 企业注册
    async firmReg (params) {
      return await post("/firm/register",params)
    },
    // 用户注册
    async userReg (params) {
      return await post("/register",params)
    },
    // 企业忘记密码
    async firmReset (params) {
      return await post ('/firm/forgot',params)
    },
    // 用户忘记密码
    async userReset (params) {
      return await post ('/forgot',params)
    },
    // 登出
    async loginOut (params) {
        return await post ('/logout',params)
    },
    // 更新用户头像
    async userAvatar (params) {
      return await putfun ('/user/avatar',params)
    },
    // 修改手机号
    async modifyPhone (params) {
        return await putfun('/user/mobile',params)
    },
    // 设置支付密码
    async payPassword (params) {
      return await post('/common/update-pay-password',params)
    },
    // 验证支付密码
    async checkPayPassword (params) {
      return await post('/common/check-pay-password',params)
    },
    // 上传文件签名
    async resource (params) {
        return await post ('/common/resource-signature',params)
    },
    // 手动上传图片
    async ossPost (url,params) {
      return await post (url,params)
    },
    // 删除上传文件
    async deleteFile (data) {
        return await deletefn (`/common/resource-destroy/${data}`)
    },
    // 拉取企业信息
    async firmInfo (params) {
      return await get ('/firm',params)
    },
    // 拉取个人信息
    async userInfo (params) {
      return await get ('/user',params)
    },
    // 认证
    async userAuthentication (params) {
      return await post ('/user',params)
    },
    // 基本资料更新
    async basicInfo (params) {
      return await putfun ('/user/user-update',params)
    },
    // 我的档案提交
    async postArchives (params) {
      return await post ('/user-record',params)
    },
    // 拉取个人档案信息
    async getArchives (params) {
      return await get ('/user-record',params)
    },
  // 导出个人档案
    async downloadFile (params) {
      return await get (`/record-export/${params}`)
    },
    // 下载记录
    async downloadRecord (params) {
      return await get ('/common/materials-download',params)
    },
    // 学习记录
    async studyRecord (params) {
      return await get ('/user/study-recodes',params)
    },
    // 我的收藏
    async  ownCollect(params) {
      return await get ('/common/collects',params)
    },
    // 支付
    async pay(params) {
      return await post ('/common/pay',params)
    },
    // 支付流水
    async payLog(params) {
      return await get ('/common/pay-log',params)
    },
    // 钱包余额
    async wallet(params) {
      return await get ('/common/wallet',params)
    },
    // 账号绑定信息
    async accountRelationInfo(params) {
      return await get ('/common/bind-account',params)
    },
    // 账号绑定
    async accountRelation(params) {
      return await post ('/common/bind-account',params)
    },
    // 粉丝 or 关注
    async userFollower(params) {
      return await get ('/common/follow',params)
    },
    // 我的等级
    async userLevel(params) {
      return await get ('/user/user-level',params)
    },
    // 设计师个人主页详情
    async designerInfo(params) {
      return await get (`/firm/designers/info/${params}`)
    },
    // 设计师个人主页作品列表
    async designerWork(params) {
      return await get (`/firm/designers/works/${params.id}`,params)
    },
    // 设计师个人主页帖子详情
    async designerQuestions(params) {
      return await get (`/firm/designers/questions/${params.id}`,params)
    },
    // 企业个人主页
    async enterpriseInfo(params) {
      return await get (`/firm-info/${params}`)
    },
    // 意见反馈分类
    async feedbackCategory(params) {
      return await get ('/common/feedback-category')
    },
    // 意见反馈提交
    async feedbackSubmit(params) {
      return await post ('/common/feedback',params)
    },
    // 推荐设计师
    async designerList (params) {
      return await get ('/firm/designers',params)
    },
    /*  兴趣领域*/
    async interest_put (data) {
      return await putfun ('/user/tags',data)
    },
    // 顶部广告
    async top_advert (params) {
      return await get ('/common/advert',params)
    },
}



// WEBPACK FOOTER //
// ./src/request/api.js